import React from "react";

const Carousel = ({ items, currentIndex, renderItem }) => {
  return (
    <div className="relative w-full max-w-lg mx-auto overflow-hidden">
      <div
        className="w-full flex flex-row transition-transform duration-500 ease-in-out transform"
        style={{ transform: `translateX(-${currentIndex * 100}%)` }}
      >
        {items.map((item, index) => (
          <div key={index} className="flex-shrink-0 relative w-full h-full">
            {renderItem(item, index)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Carousel;
